export enum BonLivraisonDLCStatus {
  NA,
  Conforme,
  NonConforme
}

// tslint:disable-next-line: variable-name
export const InvalidDLCStatuses = [BonLivraisonDLCStatus.NonConforme];
